import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { FileText } from 'lucide-react'
import { TemplateList } from '@/components/shared/TemplateList'

type Template = { id: string; name: string; file_url: string | null }

type Props = {
  filing: { id: string; type_name: string; business_name: string }
  templates: Template[]
}

export default function DocumentsShow({ filing, templates }: Props) {
  return (
    <DashboardLayout
      title={`Documents — ${filing.type_name}`}
      breadcrumbs={[
        { label: 'Compliance Filings', href: 'compliance_filings' },
        { label: filing.type_name, href: `compliance_filings/${filing.id}` },
        { label: 'Documents' }
      ]}
    >
      <div>
        <div className="mb-8">
          <div className="flex items-center gap-2 mb-1">
            <FileText className="w-4 h-4 text-muted-foreground" />
            <h1 className="text-xl font-semibold tracking-tight">Documents</h1>
          </div>
          <p className="text-sm text-muted-foreground">{filing.type_name}</p>
        </div>

        <div className="space-y-6">
          <TemplateList title="Document Templates" templates={templates || []} />
        </div>
      </div>
    </DashboardLayout>
  )
}
